import React, { useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../../utils/AuthContext';

const ScreenshotComponent = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const { auth } = useAuth();
  const userId = auth.userId;
  const username = auth.username;
  useEffect(() => {
    const startVideo = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = () => {
            videoRef.current.play();
          };
        }
      } catch (err) {
        console.error('Error accessing the camera', err);
      }
    };

    startVideo();

    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, []);

  const sendScreenshotToServer = async (blob) => {
    const formData = new FormData();
    formData.append('Image', blob, 'screenshot.png');
    formData.append('UserId', userId);
    formData.append('username', username);
    formData.append('capturetype', "camera");

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Exam/upload-screenshot`, formData, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('Screenshot uploaded successfully:', response.data);
    } catch (error) {
      console.error('Error uploading screenshot:', error);
    }
  };

  const captureAndUpload = useCallback(() => {
    if (videoRef.current && canvasRef.current) {
      const context = canvasRef.current.getContext('2d');
      canvasRef.current.width = videoRef.current.videoWidth;
      canvasRef.current.height = videoRef.current.videoHeight;
      context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
      
      canvasRef.current.toBlob((blob) => {
        if (blob) {
          sendScreenshotToServer(blob);
        }
      }, 'image/png');
    }
  }, [auth.token]);

  useEffect(() => {
    const intervalId = setInterval(captureAndUpload, 20000); // Capture and upload every 20 seconds

    return () => clearInterval(intervalId);
  }, [captureAndUpload]);

  return (
    <div>
      <video ref={videoRef} width="640" height="480" style={{ display: 'none' }} playsInline />
      <canvas ref={canvasRef} width="640" height="480" style={{ display: 'none' }} />
    </div>
  );
};

export default ScreenshotComponent;
